import {social} from "../data"
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

function Social(){
    const icons = [
        {
          img : <LinkedInIcon/> ,
          path : "https://www.linkedin.com/in/ghanisht-khurana-355b691b0/"
        },
        {
          img : <GitHubIcon/> ,
          path : "https://github.com/Ghanishtkhurana/"
        },
      ]
    return (
        <ul className="flex space-x-6">
            {icons.map((item,index)=>{
                return (
                    <li className="flex justify-center items-center text-violet-500" key={index}>
                        <a href={item.path} className="text-base" target="_blank">
                            {item.img}
                        </a>
                    </li>
                )
            })}
        </ul>
    )
}

export default Social